module.exports = __webpack_public_path__ + "img/defaultImg.e726fa4a.png";